/* ------------------------------------------------------------------------ */
/*		File: Thankyou.tsx                                                  */
/*		Description: Thank you page definition                              */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React from "react";
import { useTranslation, withTranslation } from "react-i18next";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import Card_360 from "../../components/cmpCard_360/cmpCard_360";

import "../../scss/general.css"; 
import "./thankyou.css";
import Meta from "../../components/GenericComponents/meta";

/* ------------------------------------------------------------------------ */

const Thankyou: React.FC = () => {

    const { t } = useTranslation();
    const infoThankyou:any = t("thankyou", { returnObjects: true });

    return (
        <div className="header-parent">
            <Meta page={"thankyou"} />
            <div className="cssThankyou">
                <IntroComponent
                        label={infoThankyou.label}
                        description={infoThankyou.description}
                    />

                <Card_360 card={infoThankyou.content[0].content[0]}/>
                <div className="cssRowBetween info_thankyou_cards">
                    <Card_360 card={infoThankyou.content[0].content[1]}/>
                    <Card_360 card={infoThankyou.content[0].content[2]}/>
                </div>
            </div>
        </div>
    )
}

export default withTranslation('translation', { withRef: true }) (Thankyou);